import { render } from "./gift.vue?vue&type=template&id=2e2bc81a&scoped=true"
import script from "./gift.vue?vue&type=script&lang=js"
export * from "./gift.vue?vue&type=script&lang=js"

import "./gift.vue?vue&type=style&index=0&id=2e2bc81a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2e2bc81a"

export default script